import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { List } from './List';

export const Main = () => {
  return (
    <Switch>
      <Route path='/admin/usage-reports' component={List} exact={true} />
    </Switch>
  );
};
